export const PERIOD = {
  DAY: "day",
  DAYS: "days",
  ISO_WEEK: "isoWeek",
  WEEK: "week",
  WEEKS: "weeks",
  MONTH: "month",
  MONTHS: "months",
  FULL: "full",
  QUARTER: "quarter",
  YEAR: "year",
  YEARS: "years",
  CUSTOM: "custom"
};

export const DATEPICKER_DATE_TYPE = {
  DATE: "date",
  MONTH: "month"
};
